/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025.
 */
var FooterLogo = function (_a) {
    var children = _a.children;
    return children;
};
export default FooterLogo;
